module.exports = __webpack_public_path__ + "img/bbk-logo-black-digi.79ab9253.jpg";